export default "__VITE_ASSET__YdG4EMNV__"